<template lang="pug">
  v-radio-group.mt-0(v-model="selectedCard" hide-details)
    template(v-if="offers.isFetching")
      v-skeleton-loader(type="list-item-two-line@3")
    template(v-else)
      template(v-if="offers.totalCount === 0")
        .text-center.pa-4
          .text-xs.neutral500--text No available offers
      template(v-else)
        v-card.round-xl.pa-4.mb-3(v-for="item in offers.data" :key="item.id" outlined :class="[{ 'border-card-selected': selectedCard && selectedCard.id === item.id }]" @click="handleSelectedCard(item)")
          redeem-offer-item-property(:item="item" has-radio-button)
    .d-flex.justify-end.mt-4(v-if="offers.totalCount > offers.pageSize")
      yc-pagination-custom(v-model="offers.currentPage" :parentPageSize.sync="offers.pageSize" :count="offers.totalCount" attach menu-top @input="pageChanged")
</template>

<script>
import RedeemOfferItemProperty from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferItemProperty.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    RedeemOfferItemProperty
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    leadId: {
      type: Number,
      default: null
    }
  },
  mounted() {
    this.fetchCoupons()
  },
  data() {
    return {
      selectedCard: null,
      offers: {
        isFetching: true,
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        data: [],
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  methods: {
    ...mapActions(['showMessage']),
    handleSelectedCard(item) {
      this.selectedCard = item
      this.$emit('input', item)
    },
    pageChanged() {
      this.fetchCoupons()
    },
    async fetchCoupons() {
      if (!this.customer) return

      const url = `/marketing/${this.company.slug}/coupons`
      const params = {
        customer: this.customer.id,
        lead: this.leadId,
        ordering: 'expired_at',
        page_size: this.offers.pageSize,
        page: this.offers.currentPage,
      }
      try {
        this.offers.isFetching = true
        const { data } = await this.$axios.get(url, { params })
        this.offers.totalCount = data.count
        this.offers.data = data.results
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.offers.isFetching = false
      }
    }
  },
}
</script>

<style scoped>
.border-card-selected {
  border: 1px solid #0D6EFF !important;
}
</style>